export default {
    en: {
        id: 'exercise1',
        answers: [
            {
                title: `<div class="box-title">High sales force productivity</div>`,
                answer: 3,
                hasArrow: true
            },
            {
                title: '<div class="box-title">Despite investment, sales force productivity figures remain where they were 10 years ago</div>',
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Low sales force productivity limits-ability to</div>
                        <div>- Offset slow market growth</div>
                        <div>- Out-sell competitors</div>
                        <div>- Out-maneuver online sellers</div>
                `,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Interview 25 CEOs of billion dollar companies with sales forces</div>
                    <div>- What is behind the low productivity?</div>
                    <div>- What can we do about it?</div>
                `,
                answer: 4,
                hasArrow: true
            }
        ],
        image: '5b1-1.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5b/practiceDefiningProblem/i18n/exercise1.js